var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.cbe749119021ed2c77442611865ef4e0.svg#j';
                    var viewUrl = 'sprites.cbe749119021ed2c77442611865ef4e0.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };